var $ = jQuery;


window.addEventListener('storage', (e) => {
  console.log(`Key Changed: ${e.key}`);
  console.log(`New Value: ${e.newValue}`);
});

$(document).ready(function() {

  if(window.location.pathname == "/contact-us/" && window.localStorage.formtext) {
    $("#form-field-message").val(window.localStorage.formtext);
    window.localStorage.removeItem("formtext");
  }

  if(!sessionStorage.ctaData) {
    $.get("/wp-json/acf/v3/options/options", function(data) {
      sessionStorage.ctaData = JSON.stringify(data.acf.menu_call_to_actions);
      window.ctaData = data.acf.menu_call_to_actions;
    });
  } else {
    window.ctaData = JSON.parse(sessionStorage.ctaData);
  }


  if($(".onlinetrainingform").length > 0) {
    if(getCookie("OnlineCourse") == "signedup" || localStorage.OnlineCourse === "signedup") {
      $(".onlinetrainingform").hide();
      $(".elearningcourse").show();
    }

    $(".elementor-editor-active .onlinetrainingform").show();
    $(".elementor-editor-active .elearningcourse").show();
  }

  // $(".videogallery .gallery-item-caption-wrap.caption-style-card").on("click", function() {
  //   var video = $(this).parent().find("a").click();
  // });

  if (!$('body').hasClass('dropdown-menus-enabled')) {
    $("#menu-main-menu .menu-item-has-children a:not(.submenu a)").hover(function() {

      var that = $(this);

      if(!that.parent().parent().hasClass("sub-menu")) {
        $(".menu-item-has-children").removeClass("active");

        $(this).parent().addClass("active");
        var subMenu = $(this).parent().find(".sub-menu");

        if(subMenu.find(".page").length == 0) {
          subMenu.prepend("<li class='page'>" + that[0].innerHTML + "</li>");
        }

        if(subMenu.find(".close").length == 0) {
          subMenu.prepend("<li class='close'><a>&times;</a></li>");
        }

        for(var i = 0; i < window.ctaData.length; i++) {
          if(window.ctaData[i].id.toLowerCase() == that[0].innerHTML.toLowerCase()) {

            if(subMenu.find(".upsell").length == 0) {
              subMenu.append(`
                <li class="upsell">
                  <a style="background: url(${window.ctaData[i].image.sizes.medium_large}) no-repeat center center / cover;"
                    href="${window.ctaData[i].link.url}">
                      <span>${window.ctaData[i].link.title}</span>
                      <span>find out more ></span>
                    </a>
                </li>`);
            }

          }

        }

        setTimeout(function() {
          $("li.close a").click(function() {
            $(".menu-item-has-children").removeClass("active");
          })
        }, 100);
      }

    });
  } else {
    $("#menu-main-menu .menu-item-has-children a:not(.submenu a)").hover(function() {
      var that = $(this);

      if(!that.parent().parent().hasClass("sub-menu")) {
        var subMenu = $(this).parent().find(".sub-menu");

        for(var i = 0; i < window.ctaData.length; i++) {
          if(window.ctaData[i].id.toLowerCase() == that[0].innerHTML.toLowerCase()) {

            if(subMenu.find(".upsell").length == 0) {
              subMenu.append(`
                <li class="upsell">
                  <a style="background: url(${window.ctaData[i].image.sizes.medium_large}) no-repeat center center / cover;"
                    href="${window.ctaData[i].link.url}">
                      <span>${window.ctaData[i].link.title}</span>
                      <span>find out more ></span>
                    </a>
                </li>`);
            }
          }
        }
      }
    });
  }

  function handleMobileMenu(e, that) {

    if(!that.parent().parent().hasClass("sub-menu")) {

      if(e.offsetX < that.width() - 30) {
        return;
      }

      e.preventDefault();
      $(".menu-item-has-children").removeClass("active");

      that.parent().addClass("active");
      //var subMenu = that.parent().find(".sub-menu");

    }

  }

  // We need to watch for the jQuery selector, as the popup is generated through AJAX
  setInterval(function() {
    var mobileMenuSelector = $(".mobilemenu .menu-item-has-children a:not(.submenu a)");

    if(mobileMenuSelector.length > 0) {

      var ev = $._data(mobileMenuSelector[0], 'events');

      if(!ev || !ev.click) {
        mobileMenuSelector.on("click", function(e) { var that = $(this); handleMobileMenu(e, that) } );
      }

    }
  }, 200);


  if (window.location.pathname == "/e-learning-course/" || window.location.pathname == "/brew-course/") {
    var val = "";
    var name = "OnlineCourse" + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        val = c.substring(name.length, c.length);
      }
    }

    if(val != "signedup" && localStorage.OnlineCourse !== "signedup") {
      window.location = "/elearning-please-register/";
    }
  }

  /** Recipe filter */
  $('.select-hover span input.filter-search').on('focus', function() {
    $('.select-hover').removeClass('active');
    $(this).parents('.select-hover').addClass('active');
  });

  $('.select-hover span.clear-input').on('click', function() {
    $(this).parents('.select-hover span').removeClass('has-text');
    $(this).parents('.select-hover').find('input.filter-search').val('').trigger('change');

    /** Show all list items */
    $(this).parents('.select-hover').find('ul li').show();
  });

  var findOne = function(haystack, arr) {
    return arr.some(function (v) {
      return haystack.indexOf(v) >= 0;
    });
  };

  $('.select-hover li').on('click', function() {
    var $self = $(this);

    if ($self.parents('.select-hover').hasClass('multiple')) {
      if ($self.attr('data-filter').indexOf('*') >= 0) {
        $self.parents('ul').find('li:not([data-filter$="*"])').removeClass('item-selected');
        $self.toggleClass('item-selected');
      } else {
        $self.parents('ul').find('li[data-filter$="*"]').removeClass('item-selected');
        $self.toggleClass('item-selected');
      }
    } else {
      $self.parents('ul').find('li').removeClass('item-selected');
      $self.toggleClass('item-selected');
    }

    /**
     * Loop through all elements in the grid.
     * Hide all and show the ones with matching classes
     */
    var filterClassList = [];

    $('.select-hover').each(function() {
      $(this).find('li.item-selected').each(function() {
        var filter = $(this).attr('data-filter');

        if (filter.indexOf('*') >= 0) {
          $(this).parents('ul').find('li:not([data-filter="'+filter+'"]').each(function() {
            var filterNew = $(this).attr('data-filter');

            filterClassList.push(filterNew);
          });
        } else {
          filterClassList.push(filter);
        }
      });
    });

    if (filterClassList.length > 0) {
      $('.recipe-card').each(function() {
        var filters = $(this).attr('data-filters').split(' '),
          exists = findOne(filterClassList, filters);

        if (exists) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    } else {
      $('.recipe-card').show();
    }
  });

  $('.select-hover span input.filter-search').on('keyup', function() {
    // Declare variables
    var input, filter, ul, li, txtValue;
    input = $(this);
    filter = input.val().toUpperCase();
    ul = input.parents('.select-hover').find('ul');
    li = ul.find('li');

    // Loop through all list items, and hide those who don't match the search query
    $(li).each(function() {
      txtValue = $(this).text();

      if (txtValue.toUpperCase().indexOf(filter) > -1) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    var liCount = $(li).length;

    if (ul.find('li.dropdown-item:hidden').length === (Number(liCount) - 1)) {
      ul.find('li.no-matching').show();
    } else {
      ul.find('li.no-matching').hide();
    }

    if ($(this).val().length > 0) {
      $(this).parents('span').addClass('has-text');
    } else {
      $(this).parents('span').removeClass('has-text');
    }
  });

  $(document).click(function (e) {
    if ($(e.target).is('.select-hover, .select-hover *')) {
      return;
    }

    $('.select-hover').each(function () {
      $(this).removeClass('active');
    });
  });

  $('.recipe-card').each(function() {
    new Swiper($(this), {
      effect: 'fade',
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.elementor-swiper-button-next',
        prevEl: '.elementor-swiper-button-prev',
      },
    });
  });
  /** End - recipe filters */

});


function getCookie(c_name) {
  if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          let c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) c_end = document.cookie.length;
          return unescape(document.cookie.substring(c_start, c_end));
      }
  }
  return "";
}



// WEBPACK FOOTER //
// ./scripts/autoload/jQuery.js